// C6 · صفحة الموظف — per-screen i18n namespace (Arabic-first + English parity).
// Merged into the shared bundle by i18n.ts's require.context over ./screens/*.js.
module.exports = {
  ar: {
    'employee-page': {
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل بيانات الموظف',
      breadcrumbEmployees: 'الموظفين',
      searchPlaceholder: 'ابحث في مطالبات الموظف…',
      edit: '✏️ تعديل',
      suspend: '⏸ إيقاف',
      reactivate: '▶️ تفعيل',
      leave: '🚪 تسجيل مغادرة',
      cardLabel: 'كارت',
      status: { active: 'نشط', suspended: 'موقوف', left: 'مغادر' },
      claimStatus: {
        new: 'جديدة',
        review: 'تحت المراجعة',
        pending_docs: 'ناقصة مستندات',
        approved: 'مقبولة',
        rejected: 'مرفوضة',
      },
      gender: { male: 'ذكر', female: 'أنثى' },
      personal: {
        title: '👤 البيانات الشخصية',
        nationalId: 'الرقم القومي',
        birthDate: 'تاريخ الميلاد',
        gender: 'النوع',
        phone: 'الموبايل',
        email: 'البريد',
        hireDate: 'تاريخ التعيين',
      },
      policy: {
        title: '🛡️ البوليصة والتغطية',
        number: 'رقم البوليصة',
        validity: 'السريان',
        annualCap: 'السقف السنوي',
        coverages: 'التغطيات',
        remaining: 'المتبقّي',
        usedPrefix: 'استهلك',
        consumed: 'المستهلك',
        usageUnavailable: 'لا يوجد سقف سنوي محدد لهذه البوليصة، لذلك لا يُحتسب الاستهلاك والمتبقي.',
        usedPct: 'تم استهلاك {n}% من السقف السنوي',
        ofAnnualCap: 'من السقف السنوي',
      },
      claims: {
        title: '📋 مطالبات الموظف',
        count: '{n} مطالبة',
        colNo: 'رقم',
        colType: 'النوع',
        colAmount: 'المبلغ',
        colDate: 'التاريخ',
        colStatus: 'الحالة',
        empty: 'لا توجد مطالبات لهذا الموظف',
      },
      timeline: {
        title: '🕓 سجل المتابعة',
        hired: 'تم التعيين',
        current: 'الحالة الحالية',
        now: 'الآن',
      },
      currency: 'ج',
    },
  },
  en: {
    'employee-page': {
      loading: 'Loading…',
      error: 'Something went wrong while loading the employee',
      breadcrumbEmployees: 'Employees',
      searchPlaceholder: 'Search the employee’s claims…',
      edit: '✏️ Edit',
      suspend: '⏸ Suspend',
      reactivate: '▶️ Reactivate',
      leave: '🚪 Register leave',
      cardLabel: 'Card',
      status: { active: 'Active', suspended: 'Suspended', left: 'Left' },
      claimStatus: {
        new: 'New',
        review: 'Under review',
        pending_docs: 'Docs pending',
        approved: 'Approved',
        rejected: 'Rejected',
      },
      gender: { male: 'Male', female: 'Female' },
      personal: {
        title: '👤 Personal details',
        nationalId: 'National ID',
        birthDate: 'Date of birth',
        gender: 'Gender',
        phone: 'Mobile',
        email: 'Email',
        hireDate: 'Hire date',
      },
      policy: {
        title: '🛡️ Policy & coverage',
        number: 'Policy no.',
        validity: 'Validity',
        annualCap: 'Annual cap',
        coverages: 'Coverages',
        remaining: 'Remaining',
        usedPrefix: 'Used',
        consumed: 'Consumed',
        usageUnavailable: 'This policy has no annual cap, so consumption and remaining balance are not calculated.',
        usedPct: '{n}% of the annual cap consumed',
        ofAnnualCap: 'of the annual cap',
      },
      claims: {
        title: '📋 Employee claims',
        count: '{n} claims',
        colNo: 'No.',
        colType: 'Type',
        colAmount: 'Amount',
        colDate: 'Date',
        colStatus: 'Status',
        empty: 'This employee has no claims',
      },
      timeline: {
        title: '🕓 Follow-up log',
        hired: 'Hired',
        current: 'Current status',
        now: 'Now',
      },
      currency: 'EGP',
    },
  },
};
